var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticStyle:{"background-color":"#2D2D2D"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerBox ch-container"},[_c('div',{staticClass:"copyrightBox"})])
}]

export { render, staticRenderFns }